import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  DateTimeInput,
  FormDataConsumer,
  usePermissions,
  useRedirect,
  useNotify
} from "react-admin";
import {
  hasValue,
  leastOneOption,
  validDate
} from "../../utils/schemas";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import useForRequest from "../../ra/hook/useForRequest";
import { Box, Grid } from "@mui/material";
import { Save as ToolbarSave } from "../../ra/toolbar";
import SelectCollectionPointPassportAdmin from "../../components/select-collection-point-passport-admin";
import DialogErroCustomerPassportPhysical from "../../components/dialogs/dialog-erro-customer-passport-physical";
import SearchCustomer from "../../components/search-customer";

const Schema = (permissions) =>
{
  var obj =
  {
    customer_passport_data: hasValue(),
    date_withdrawal: validDate()
  };

  if (permissions && permissions.is_master === true)
  {
    obj.collection_point_passport_id = leastOneOption();
    obj.collection_point_passport_admin_id = leastOneOption();
  }

  return Yup.object(obj);
};

const CustomerPassportPhysicalCreate = () =>
{
  const { permissions } = usePermissions();
  const { action } = useForRequest();
  const redirect = useRedirect();
  const notify = useNotify();
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);

  const customerPassportPhysicalSave = async (data) =>
  {
    // CUSTOMER NOT SEARCHED
    if (!data.customerData)
    {
      notify("É necessário buscar um usuário!", { type: "error" });
      return;
    }

    // SET CUSTOMER ID
    data.customer_id = data.customerData.id;

    const { error } = await action("customer-passport-physical", "POST", data);
    if (error)
    {
      const apiData = error?.response?.data?.data;
      const hasDialogData =
        apiData &&
        typeof apiData === "object" &&
        (apiData.customer_name || apiData.date_withdrawal_format || apiData.collection_point_passport_name);

      if (hasDialogData)
      {
        setError(apiData);
        setOpen(true);
      }
      else
      {
        setOpen(false);
        setError(null);
        notify(error?.response?.data?.message || "Erro ao registrar retirada de passaporte físico.", { type: "error" });
      }

      return;
    }

    notify("Entrega de Passaporte Físico registrada com sucesso!", { type: "success" });
    redirect("/customer-passport-physical");
  };

  const handleClose = () =>
  {
    setOpen(false);
    setError(null);
  };

  return (
    <>
      <Create
        title="Nova Entrega de Passaporte Físico"
        redirect="list">
        <SimpleForm
          noValidate
          onSubmit={customerPassportPhysicalSave}
          resolver={yupResolver(Schema(permissions))}
          toolbar={<ToolbarSave />}>
          <Box
            sx={{
              width: { xs: "100%", md: "auto" },
              maxWidth: { xs: "100%", md: 980 },
              display: { xs: "block", md: "inline-block" },
              alignSelf: "flex-start",
            }}>
            <Grid container columnSpacing={2} rowSpacing={2}>
            {
              (permissions && permissions.is_master === true) ?
              <>
                <Grid size={{ xs: 12, md: 6 }}>
                  <ReferenceInput source="collection_point_passport_id" sort={{ field: "name", order: "ASC" }} reference="setup/passport-physical-collection-points-passport">
                    <SelectInput label="Ponto de Retirada" optionText="name" optionValue="id" fullWidth isRequired />
                  </ReferenceInput>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} />

                <FormDataConsumer>
                {
                  ({ formData }) => formData && formData.collection_point_passport_id ? <SelectCollectionPointPassportAdmin /> : null
                }
                </FormDataConsumer>
              </> : null
            }

            <SearchCustomer />

            <Grid size={{ xs: 12, md: 8 }}>
              <TextInput source="customer_passport_and_name" label="Usuário" fullWidth isRequired readOnly />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <DateTimeInput source="date_withdrawal" label="Data da Retirada" fullWidth isRequired />
            </Grid>
            </Grid>
          </Box>
        </SimpleForm>
      </Create>

      <DialogErroCustomerPassportPhysical
        open={open}
        error={error}
        onClose={handleClose}
      />
    </>
  );
};

export default CustomerPassportPhysicalCreate;
